/**
 * userService.js — CRUD de usuarios para el panel de administración.
 */
import api from './api';

const userService = {
  /** Lista usuarios con filtros opcionales: { search, role, page, per_page } */
  async list(params = {}) {
    const { data } = await api.get('/users', { params });
    return data;
  },

  /** Crea un nuevo usuario */
  async create(userData) {
    let payload = userData;
    let headers = {};

    if (userData instanceof FormData) {
      payload = userData;
      headers = { 'Content-Type': 'multipart/form-data' };
    }

    const { data } = await api.post('/users', payload, { headers });
    return data;
  },

  /** Obtiene un usuario por ID */
  async get(id) {
    const { data } = await api.get(`/users/${id}`);
    return data;
  },

  /** Actualiza un usuario (campos parciales) */
  async update(id, userData) {
    let payload = userData;
    let headers = {};

    if (userData instanceof FormData) {
      // Laravel no soporta archivos en PUT real, usamos POST + _method=PUT
      payload = userData;
      if (!payload.has('_method')) {
        payload.append('_method', 'PUT');
      }
      headers = { 'Content-Type': 'multipart/form-data' };
      const { data } = await api.post(`/users/${id}`, payload, { headers });
      return data;
    }

    const { data } = await api.put(`/users/${id}`, payload);
    return data;
  },

  /** Elimina un usuario */
  async remove(id) {
    const { data } = await api.delete(`/users/${id}`);
    return data;
  },
};

export default userService;
